import { render, staticRenderFns } from "./ProviderTaxonomyCodes.vue?vue&type=template&id=0f7cf93e&"
import script from "./ProviderTaxonomyCodes.vue?vue&type=script&lang=js&"
export * from "./ProviderTaxonomyCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports